import { useEffect, useRef, useState } from 'react';
import { ChargingSocket } from '@/ws/client';
import type { WsEvent } from '@/ws/events';

/**
 * Último evento do WS da sessão. `onEvent` (opcional) recebe TODO frame: o
 * estado `lastEvent` só guarda o mais recente, e dois frames colados (o
 * `balance_warning` chega junto do `meter_update`) caem no mesmo render do
 * React — quem precisa de um evento específico não pode depender dele.
 */
export function useChargingSocket(
  sessionId: string | null,
  token: string | null,
  onEvent?: (event: WsEvent) => void
): WsEvent | null {
  const [lastEvent, setLastEvent] = useState<WsEvent | null>(null);
  // Ref pra trocar o callback sem reconectar o socket.
  const onEventRef = useRef(onEvent);
  onEventRef.current = onEvent;

  useEffect(() => {
    if (!sessionId || !token) return;
    const socket = new ChargingSocket(sessionId, token);
    const unsubscribe = socket.subscribe((event) => {
      onEventRef.current?.(event);
      setLastEvent(event);
    });
    socket.connect();
    return () => {
      unsubscribe();
      socket.close();
    };
  }, [sessionId, token]);

  return lastEvent;
}
